var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"spacer",style:({height: _vm.content.height + 'px'})}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }